import { render } from "./createQuote.vue?vue&type=template&id=a21dafd4"
import script from "./createQuote.vue?vue&type=script&lang=js"
export * from "./createQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__